export enum EWebSocketTypes {
  CompanyBlocked = 'company-blocked',
  CompanyBillingUpdated = 'company-billing-updated',
  CallRecordingAvailable = 'call-recording-available',
}
